<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component
        :is="Component"
        :key="route.fullPath"
        class="row align-items-center justify-content-center m-0"
      />
    </keep-alive>
  </router-view>
</template>
<script setup>
</script>

<style scoped>
html,
body {
  margin: 0;
  background-color: #fff !important;
  padding: 0;
}
</style>
<style>
body {
  margin: 0;
  background-color: #fff !important;
  padding: 0;
}
.login-wrap {
  min-height: 100vh;
  background: #ffffff !important;
  padding: 0 80px;
  box-sizing: border-box;
}

.login-box-form {
  height: 100%;
  gap: 40px;
}

.login-signin {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-control,
.form-control:focus {
  color: #39457c;
}

.login-signin .form-control {
  padding: 16px 20px 16px 24px !important;
  height: 56px;
  background: #f5f9ff !important;
  border-radius: 16px;
  font-size: 16px;
  border: none;
}

.login-signin .form-control:hover {
  background: #e6effc !important;
}

.login-signin input::placeholder,
.login-signin input::-moz-placeholder,
.login-signin input:-moz-placeholder,
.login-signin input:-ms-input-placeholder {
  color: #8f96b8 !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.login-box-img {
  padding: 140px;
  color: #fff;
  background-image: url("@/assets/login-wave.svg");
  background-size: cover;
  background-color: #7282cb;
  font-weight: 400;
}

form .form-group {
  position: relative;
}

@media (max-width: 767px) {
  .bg-main-img {
    background-size: cover;
  }
  .login-wrap {
    padding: 0 10px;
  }
  .login-box-logo {
    top: 10px;
    left: 10px;
  }
  .login-box-img {
    padding: 10px;
  }
  .login-box-img img {
    width: 100%;
  }
  .promo-background {
  	display: none !important;
  }
}

.promo-background {
  background-image: url("@/assets/login-wave.svg");
  background-size: cover;
  background-position: bottom;
  background-color: #7282cb;
}

@media (min-width: 767px) {
  .lv-h-100 {
    height: 100%;
  }
}
</style>
